import { ALLOWED_LOCALES } from '@/helpers/translationsHelper.ts'

import type { ReviewsEntityDocumentEditData } from '../../ReviewsManagement/types.ts'

export const splitDocumentsForMutations = (documents: ReviewsEntityDocumentEditData[]) => {
  const documentsToCreate = documents
    .filter((document) => document.id === null && !document.deleted)
    .map((document) => ({
      position: document.position,
      nameTranslations: ALLOWED_LOCALES.map((lang) => ({ locale: lang, value: document.name[lang] })),
      file: document.file,
      preview: document.previewFile || undefined,
    }))

  const documentsToUpdate = documents
    .filter((document) => document.id !== null && document.updated && !document.deleted)
    .map((document) => ({
      id: document.id!,
      nameTranslations: ALLOWED_LOCALES.map((lang) => ({ locale: lang, value: document.name[lang] })),
      position: document.position,
      file: document.file || undefined,
      preview: document.previewFile || undefined,
      deleteCustomPreview: document.previewDeleted,
    }))

  const documentsToDelete = documents.filter((document) => document.id !== null && document.deleted).map((document) => document.id!)

  return {
    documentsToCreate,
    documentsToUpdate,
    documentsToDelete,
  }
}
